import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';

if (document.getElementById(
  'react-component-g4-logistics-portal-view-jobs-for-driver')) {
  let driverId = document.getElementById(
    'react-component-g4-logistics-portal-view-jobs-for-driver'
  ).getAttribute('data-driver-id');
  ReactDOM.render(<JobsTable
      url = {"/api/v1/portal/jobs/driver/"+driverId}
      infiniteScroll={true}
      message_if_none = 'Jobs not found or available for viewing.'
    />,

    document.getElementById(
      'react-component-g4-logistics-portal-view-jobs-for-driver'
    )
  );
}
